import React from "react";
import { toPersianNumber } from "../utils/numberConversion";

function TableToolbar({ title, count, children }) {
    return (
        <div className="admin-toolbar d-flex align-items-center justify-content-between flex-wrap gap-3">
            <div className="admin-toolbar-title d-flex align-items-center gap-2">
                <h4 className="mb-0">{title}</h4>
                {typeof count === "number" && (
                    <span className="admin-count-badge">{toPersianNumber(count)} مورد</span>
                )}
            </div>
            <div className="admin-toolbar-actions d-flex align-items-center gap-2 flex-wrap">
                {children}
            </div>
        </div>
    );
}

export default TableToolbar;
